import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import routes from "@/components/routes.js";

export default new VueRouter({
    mode: "history",
    routes
});